import styles from "./Pagination.module.css";

function Pagination({ page, totalPages, onPageChange }) {
    if (totalPages <= 1) return null;

    return (
        <div className={styles.pagination}>
            <button
                className={styles.pageBtn}
                onClick={() => onPageChange(0)}
                disabled={page === 0}
            >«</button>
            <button
                className={styles.pageBtn}
                onClick={() => onPageChange(page - 1)}
                disabled={page === 0}
            >‹</button>

            {[...Array(totalPages)].map((_, i) => (
                <button
                    key={i}
                    className={`${styles.pageBtn} ${i === page ? styles.active : ""}`}
                    onClick={() => onPageChange(i)}
                >{i + 1}</button>
            ))}

            <button
                className={styles.pageBtn}
                onClick={() => onPageChange(page + 1)}
                disabled={page === totalPages - 1}
            >›</button>
            <button
                className={styles.pageBtn}
                onClick={() => onPageChange(totalPages - 1)}
                disabled={page === totalPages - 1}
            >»</button>
        </div>
    );
}

export default Pagination;